







// In order to not create 30 different HTMLs, here the files shall be mapped to the companyId+language
// Shall return a string to load the appropriate file for that combination

export default function alocatePrivacyHtml(companyId, language) {

    let returnValue = ""
    // console.log("in func kam an: "+ companyId + language)

    switch (companyId) {

        case "eonRo":
            // console.log("eonRo")


            switch (language) {
                case "ro_RO":
                returnValue = "ro_ro_RO.html"
                break;

                case "en_GB":
                returnValue = "ro_en_GB.html"
                break;

                case "en_US":
                returnValue = "ro_en_US.html"
                break;
            }
            break;


            case "eonSwe":
                // console.log("eonSwe")


                switch (language) {
                    case "sv_SE":
                    returnValue = "sv_sv_SE.html"
                    // console.log('returnValue is' + returnValue)
                    break;

                    case "en_GB":
                    returnValue = "germany_en_UK.html"
                    break;
    
                    case "en_US":
                    returnValue = "germany_en_US.html"
                    break;
                }
            break;
            
            case "eonCz":
                // console.log("eonCz")

                switch (language) {
                    case "cs_CZ":
                    returnValue = "cz_cs_CZ.html"
                    break;

                    case "en_GB":
                    returnValue = "germany_en_UK.html"
                    break;
    
                    case "en_US":
                    returnValue = "germany_en_US.html"
                    break;
                }
            break;

            case "eonHun":
                switch (language) {
                    case "hu_HU":
                    returnValue = "hungary_hu_HU.html"
                    break;

                    case "en_GB":
                    returnValue = "germany_en_UK.html"
                    break;
    
                    case "en_US":
                    returnValue = "germany_en_US.html"
                    break;
                }
            break;
        
        case "eonStandard":
        case "westnetz":
        case "ekn":
        case "bayernwerk":
        case "westenergie":
        case "hansewerk":
        case "avacon":
        case "edn":
        case "edis":
        case "rww":
        case "e3":
        case "qualitas":
            switch (language) {
                case "de_DE":
                    returnValue = "germany_de_DE.html"
                    break;
                case "en_GB":
                    returnValue = "germany_en_UK.html"
                    break;
                case "en_US":
                    returnValue = "germany_en_US.html"
                    break;
            }
        break;
    }
    
    return returnValue


}



















